var map = {
	"./active.svg": "a3a5",
	"./add-user.svg": "d526",
	"./back.svg": "bfce",
	"./block.svg": "7d6e",
	"./bookmark.svg": "c469",
	"./bookmarks.svg": "a8a1",
	"./categories.svg": "063e",
	"./close.svg": "f3f9",
	"./context-menu.svg": "8ace",
	"./delete-audio.svg": "a14c",
	"./delete-header.svg": "eeee",
	"./edit.svg": "5665",
	"./first.svg": "62a2",
	"./home.svg": "5ad5",
	"./in-bookmarks.svg": "d488",
	"./last.svg": "d403",
	"./listen.svg": "02fc",
	"./menu.svg": "0630",
	"./next.svg": "d2ec",
	"./no-results.svg": "573d",
	"./password-dots.svg": "5c9b",
	"./play-audio.svg": "5a57",
	"./prev.svg": "1651",
	"./search.svg": "bdfc",
	"./support.svg": "6475",
	"./tags.svg": "23da",
	"./terms.svg": "1f08",
	"./to-bookmarks.svg": "fd22",
	"./trash.svg": "44c9",
	"./users.svg": "4c11",
	"./views.svg": "6ca3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bde";